
export const dealerships = {
    cmc: [
      {
        dealer: "CMC (New Holland Dealer)",
        location: "Nairobi",
        phone: "722283433",
        address: "Lusaka Rd",
      },
      {
        dealer: "CMC (New Holland Dealer)",
        location: "Nakuru",
        phone: "722316821",
        address: "Nakuru Kisumu Rd",
      },
      {
        dealer: "CMC (New Holland Dealer)",
        location: "Nanyuki/Meru",
        phone: "727443226",
        address: "Sagana Rd",
      },
      {
        dealer: "CMC (New Holland Dealer)",
        location: "Eldoret/Kitale",
        phone: "723256074",
        address: "Eldoret Kisumu Rd",
      },
      {
        dealer: "CMC (New Holland Dealer)",
        location: "Kisumu",
        phone: "722540558",
        address: "Obote Rd",
      },
      {
        dealer: "CMC (New Holland Dealer)",
        location: "Mombasa",
        phone: "720661972",
        address: "Archbishop Makarios Rd, Mombasa",
      },
    ],
    mascor: [
      {
        dealer: "Mascor (John Deere)",
        location: "Eldoret",
        phone: "254 207 602 298",
        address: "Uganda Rd",
      },
      {
        dealer: "Mascor (John Deere)",
        location: "Kisumu",
        phone: "254 207 602 294",
        address: "Obote Road, Kisumu",
      },
      {
        dealer: "Mascor (John Deere)",
        location: "Nakuru",
        phone: "254 207 602 288",
        address: "Old Nairobi Road, Nakuru",
      },
      {
        dealer: "Mascor (John Deere)",
        location: "Narok",
        phone: "254 720 935 034",
        address: "",
      },
    ],
    cfao: [
      {
        dealer: "CFAO Motors (Authorized Case IH Dealer)",
        location: "Nakuru",
        phone: "207604121",
        address: "Town East, George Morara Rd, Nakuru",
      },
      {
        dealer: "CFAO Motors (Authorized Case IH Dealer)",
        location: "Kisumu",
        phone: "719029707",
        address: "",
      },
      {
        dealer: "CFAO Motors (Authorized Case IH Dealer)",
        location: "Nanyuki",
        phone: "0719 029462",
        address: "Kenyatta Rd",
      },
    ],
    cadsMotors: [
      {
        dealer: "CADS Motors (Kericho Toyota)",
        location: "Kericho",
        phone: "254 708 698 899",
        address: "Moi Highway",
      },
    ],
    sichey: [
      {
        dealer: "Sichey Automotive EA Ltd",
        location: "Nairobi",
        phone: "254 735 500 500 / 254 768 989 407 / 254 757 487 425",
        address: "Pembe Plaza, Ground Floor Homa Bay Road/ Enterprise Road Junction Industrial Area",
      },
    ],
    terranova: [
      {
        dealer: "Terranova Automotive (Bungoma Toyota)",
        location: "Bungoma",
        phone: "254 777 222 239",
        address: "Webuye Malaba Road – Kandunyi",
      },
    ],
    uniTruck: [
      {
        dealer: "Uni-Truck World Ltd",
        location: "Nakuru",
        phone: "254 727 228 811 / 254 734 228 811 / 254 512216045",
        address: "George Morara Avenue Next To Bhogals Toyota",
      },
    ],
    fmd: [
      {
        dealer: "FMD",
        location: "Nakuru",
        phone: "722205538",
        address: "Town East, Biashara George Morara Ave Nakuru, Kiambu",
      },
      {
        dealer: "FMD",
        location: "Eldoret",
        phone: "727509018",
        address: "Lima Hse Kapseret, Kipkenyo, Kenyatta Ave, Eldoret",
      },
    ],
  };
  